module.exports = __webpack_public_path__ + "img/comparacion_anios.5a3d52e7.jpg";